import { discount } from './modules/discount'
import {arrearsRecovery} from './modules/arrearsRecovery'
import {coupon} from "./modules/coupon"
import {merchant} from "./modules/merchant"
import {pointsManagement} from "./modules/pointsManagement"
const SaleLayOut = () => import(/*webpackChunkName:'sale'*/'@/page/sale/saleLayOut.vue')
export const sale={
    path:'/sale',
    component:SaleLayOut,
    redirect:'/main/discount/posList',
    children:[
        discount,
        arrearsRecovery,
        coupon,
        merchant,
        pointsManagement
    ]
}